import { getToken } from "../../../shared/utils/common";


export class CommandDeleteLayer {
    async run(layerId: string) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/layers/${layerId}/`
        try {
            const response = await fetch(url, {
                method: "DELETE",
                headers: {"Authorization": `Token ${getToken()} `},
                })
            .then(response =>  response.json())
            .then(json => json)
            .catch(err => console.log(err));
            return response;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

   
}
